import React, {useState, useEffect} from 'react';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import AboutUsHome from '@components/AboutUs/AboutUsHome';
import AboutUsNav from '@components/AboutUs/AboutUsNav';
import AboutUsHistory from '@components/AboutUs/AboutUsHistory';
import AboutUsValues from '@components/AboutUs/AboutUsValues';
import DoctorList from '@components/AboutUs/DoctorList';
import InfrastructureCarousel from '@components/MedicalFacility/InfrastructureCarousel';
import HospitalSystem from '@components/AboutUs/HospitalSystem';
import CertAwardSection from '@components/AboutUs/AboutUsCertAward';
import AppConfig from '@services/app-config.service';
import {NextSeo} from 'next-seo';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';

export default function AboutUs(props) {
    const {seoPage} = props;
    const {locale} = useRouter();
    // Get data about us
    const [aboutus, setAboutUs] = useState([]);

    const loadAboutUs = async () => {
        const appConfigService = new AppConfig();
        try {
            const data = await appConfigService.getAppConfig({page: 'ABOUTUS', locale: locale});
            if (data) {
                setAboutUs(data);
            }
        } catch (error) {
            console.error('Error fetching App config:', error);
        }
    };

    useEffect(() => {
        loadAboutUs();
    }, [locale]);

    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
                <SlideBanner titleBanner={getLocaleContent(locale, 'page.about-us.title')} />
                <AboutUsNav />
                <AboutUsHome aboutus={aboutus} />
                <AboutUsValues aboutus={aboutus} />
                <AboutUsHistory aboutus={aboutus} />
                <DoctorList />
                <InfrastructureCarousel />
                <HospitalSystem />
                <CertAwardSection aboutus={aboutus} />
            </div>
        </>
    );
}

AboutUs.PageName = 'ABOUT-US';
